import React from 'react';
import styled from 'styled-components';
import { getFirstLetter } from '../../utils';
const Styled = styled.div `
  height: 32px;
  width: 32px;
  border-radius: 50%;
  font-size: ${(props) => props.theme.fontXXSmall};
  font-weight: ${(props) => props.theme.bold};
  color: #fff;
  background-color: ${(props) => props.theme.navyBlue};
  text-transform: uppercase;
  line-height: 32px;
  text-align: center;
  min-width: 32px;
`;
const AvatarPlaceholder = ({ givenName, surname, email, className, }) => (React.createElement(Styled, { id: "avatar_placeholder-component", className: `avatar-placeholder ${className}` },
    givenName && getFirstLetter(givenName.trim()),
    surname && getFirstLetter(surname.trim()),
    !givenName && !surname && email && getFirstLetter(email)));
AvatarPlaceholder.defaultProps = {
    className: '',
};
export default AvatarPlaceholder;
